import React from 'react';
import PropTypes from 'prop-types';
import { MortgageRatesTable as MortgageRatesTable$1 } from '@zillow/zrs-cms';

var BlockMortgageRatesTable = function BlockMortgageRatesTable(_ref) {
  var attrs = _ref.attrs,
    _ref$blockData = _ref.blockData,
    blockData = _ref$blockData === void 0 ? {} : _ref$blockData;
  var columns = attrs.columns,
    _attrs$loanToValueBuc = attrs.loanToValueBucket,
    loanToValueBucket = _attrs$loanToValueBuc === void 0 ? 'Normal' : _attrs$loanToValueBuc,
    _attrs$creditScoreBuc = attrs.creditScoreBucket,
    creditScoreBucket = _attrs$creditScoreBuc === void 0 ? 'VeryHigh' : _attrs$creditScoreBuc,
    _attrs$refinance = attrs.refinance,
    refinance = _attrs$refinance === void 0 ? false : _attrs$refinance,
    _attrs$rateLocation = attrs.rateLocation,
    rateLocation = _attrs$rateLocation === void 0 ? 'US' : _attrs$rateLocation,
    _attrs$rateCompare = attrs.rateCompare,
    rateCompare = _attrs$rateCompare === void 0 ? 'lastWeek' : _attrs$rateCompare;
  return /*#__PURE__*/React.createElement(MortgageRatesTable$1, {
    loanToValueBucket: loanToValueBucket,
    creditScoreBucket: creditScoreBucket,
    refinance: refinance,
    rateLocation: rateLocation,
    partnerId: 'RD-QCBWMVN',
    nextData: blockData,
    columns: columns,
    rateCompare: rateCompare
  });
};
BlockMortgageRatesTable.getBlockData = function (_ref2) {
  return new Promise(function ($return, $error) {
    var attrs, innerBlocks, _attrs$loanToValueBuc2, loanToValueBucket, _attrs$creditScoreBuc2, creditScoreBucket, _attrs$refinance2, refinance, _attrs$rateLocation2, rateLocation, _attrs$rateCompare2, rateCompare, data;
    attrs = _ref2.attrs, innerBlocks = _ref2.innerBlocks;
    _attrs$loanToValueBuc2 = attrs.loanToValueBucket, loanToValueBucket = _attrs$loanToValueBuc2 === void 0 ? 'Normal' : _attrs$loanToValueBuc2, _attrs$creditScoreBuc2 = attrs.creditScoreBucket, creditScoreBucket = _attrs$creditScoreBuc2 === void 0 ? 'VeryHigh' : _attrs$creditScoreBuc2, _attrs$refinance2 = attrs.refinance, refinance = _attrs$refinance2 === void 0 ? false : _attrs$refinance2, _attrs$rateLocation2 = attrs.rateLocation, rateLocation = _attrs$rateLocation2 === void 0 ? 'US' : _attrs$rateLocation2, _attrs$rateCompare2 = attrs.rateCompare, rateCompare = _attrs$rateCompare2 === void 0 ? 'lastWeek' : _attrs$rateCompare2;
    return Promise.resolve(MortgageRatesTable$1.fetchMortgageRates({
      partnerId: 'RD-QCBWMVN',
      queries: (innerBlocks === null || innerBlocks === void 0 ? void 0 : innerBlocks.map(function (block) {
        return {
          program: block.attrs.program || 'Fixed30Year',
          loanType: block.attrs.loanType || 'Conventional',
          loanSize: block.attrs.loanSize || 'Conforming',
          link: block.attrs.link || null
        };
      })) || [],
      loanToValueBucket: loanToValueBucket,
      creditScoreBucket: creditScoreBucket,
      refinance: refinance,
      rateLocation: rateLocation,
      rateCompare: rateCompare
    })).then(function ($await_1) {
      try {
        data = $await_1;
        return $return({
          rates: data
        });
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
};
BlockMortgageRatesTable.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({}),
  index: PropTypes.number
} : {};
var MortgageRatesTable = BlockMortgageRatesTable;

export { MortgageRatesTable as default };
